export default __webpack_public_path__ + "static/media/cv-man.0884d6ff.jpeg";